export default [
  {
    key: 'floema',
    title: 'Floema Jewelry',
    shortTitle: 'Floema',
    description: 'Category: Fashion',
    credit:
      'WEB DESIGN & DEVELOPMENT\n( MASTERCLASS )\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'https://floema.jewelry/',
    textWidth: 700
  },
  {
    key: 'joseph-berry',
    title: 'JOSEPH BERRY',
    shortTitle: 'JBMC',
    description: 'Category: Portfolio',
    credit:
      'WEB DESIGN & DEVELOPMENT\n( MASTERCLASS )\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'https://joseph-berry-webflow-master-class.webflow.io/',
    textWidth: 390
  },
  {
    key: 'canpolat-mimarlik',
    title: 'Canpolat MİMARLIK',
    shortTitle: 'Canpolat',
    description: 'Category: Architecture',
    credit:
      'WEB DESIGN & DEVELOPMENT\nLOGO DESIGN\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'https://canpolatmimarlik.com/',
    textWidth: 1260
  },
  {
    key: 'a90',
    title: 'A90 YAPI',
    shortTitle: 'A90 YAPI',
    description: 'Category: Construction',
    credit: 'WEB DESING & DEVELOPMENT\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'https://a90yapi.com',
    textWidth: 940
  },
  {
    key: 'nosi-insaat',
    title: 'NOSİ MİMARLIK',
    shortTitle: 'NOSİ',
    description: 'Category: Architecture',
    credit:
      'WEB DESIGN & DEVELOPMENT\nLOGO DESIGN\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'https://nosiinsaatmimarlik.com/',
    textWidth: 1260
  },
  {
    key: 'ident',
    title: 'iDENT KLİNİK',
    shortTitle: 'IDENT',
    description: 'Category: Dental Clinic',
    credit:
      'WEB DESIGN & DEVELOPMENT\nSOCIAL MEDIA MANAGEMENT\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'http://identklinik.com',
    textWidth: 390
  },
  {
    key: 'airland',
    title: 'AIRLAND HAVACILIK',
    shortTitle: 'AIRLAND',
    description: 'Category: AVIATION',
    credit:
      'WEB DESIGN & DEVELOPMENT\nSOCIAL MEDIA MANAGEMENT\nLOGO DESIGN\nDate: 2021\nDeveloper : WONEDESIGN',
    href: 'https://airlandhavacilik.com',
    textWidth: 1720
  },
  {
    key: 'sebil',
    title: 'SEBİL TRANSPORT',
    shortTitle: 'SEBİL',
    description: 'Category: LOGISTICS',
    credit: 'Search Engine Optimization\nDate: 2022\nDeveloper : WONEDESIGN',
    href: 'https://sebiltransport.com',
    textWidth: 390
  },
  {
    key: 'duybeni',
    title: 'DUY BENİ İŞİTME',
    shortTitle: 'DUYBENİ',
    description: 'Category: HEALTH',
    credit:
      'Web Design & Development\nLogo Design\nDate: 2022\nDeveloper : WONEDESIGN',
    href: 'https://duybeniisitmecihazlari.com',
    textWidth: 390
  },
  {
    key: 'lalara',
    title: 'LA LARA WORKSHOP',
    shortTitle: 'LALARA',
    description: 'Category: HOTEL',
    credit: 'Promotional Film\nDate: 2022\nWONEDESIGN - Unique & Creative',
    href: 'https://youtu.be/95vJXHiIlxo',
    textWidth: 390
  },
  {
    key: 'spektr',
    title: 'SPEKTR BOUTIQUE HOTEL & SPA',
    shortTitle: 'SPEKTR',
    description: 'Category: HOTEL',
    credit: 'Promotional Film\nDate: 2022\nWONEDESIGN - Unique & Creative',
    href: 'https://youtu.be/dJpoGQVAB2U',
    textWidth: 390
  }
];
